function Address(aLocation) {
    "use strict";
    this.AddressTypeId = -1;
    this.City = aLocation.city;
    this.Country = aLocation.country;
    this.Description = aLocation.formated_address;
    this.Latitude = aLocation.center_latitude;
    this.Longitude = aLocation.center_longitude;
    this.Name = '';
    this.Radius = 0;
    this.State = aLocation.state;
    this.Street1 = aLocation.street_1;
    this.Street2 = aLocation.street_2;
    this.StreetNumber = aLocation.street_number;
    this.ZipCode = aLocation.zip;
}
if (typeof exports !== 'undefined') {
    module.exports = Address;
}